export { default as ResourceIcon } from './resource-icon';
